<style>
  .section-disable-switch {
    display: flex;
    scale: 0.85;
    align-items: center;
    cursor: pointer;
    .v-input__slot {
      min-height: auto !important;
      height: 15px;
    }
  }
  .section-disable-switch:hover .section-disable-switch__label {
    @media (min-width: 800px) {
      opacity: 1;
    }
  }
  .section-disable-switch__label {
    font-size: 14px;
    color: #555555;
  }
  .v-application .section-disable-switch .v-input--switch__track.theme--light.primary--text {
    opacity: 1;
    color: #9dbbdf !important;
  }
  .v-application .section-disable-switch .v-input--switch__track.theme--light {
    opacity: 1;
    color: #bdbdbd !important;
  }


  .section-disable-switch .v-input--switch .v-input--selection-controls__input {
    margin-right: 0;
  }


</style>

<template>
  <div>
    <div
      class="section-disable-switch"
      @click="onSwitchClick(module)"
    >
      <v-switch
        :input-value="module.mappedToSection ? module.mappedToSection.isEnabled : module.isEnabled"
        @click.stop="onSwitchClick(module)"
        hide-details="true"
        dense
        :ripple=false
        :data-testid="`${module.id}__section-disable-switch`"
        style="margin: 0;"
      ></v-switch>
      <div
        v-if="!hideLabel"
        class="section-disable-switch__label"
        v-html="translate('ui_section_include')"
      ></div>
    </div>
  </div>
</template>

<script>
import Mixin from '../../../mixins/mixin';

export default {
  name: 'TemplateSectionDisableSwitch',
  props: ['module', 'horizontal', 'hideLabel'],
  mixins: [Mixin],
  computed: {
    section() {
      return module.mappedToSection;
    },
  },
};
</script>
